import React, { Component } from 'react';
import { Table, Pager } from 'react-bootstrap';
import 'sweetalert/dist/sweetalert.css';
import { translate } from 'react-i18next';
import SvgIcon from 'react-icons-kit';
import {checkmark} from 'react-icons-kit/icomoon/checkmark';

import WaitingModal from '../../generics/WaitingModal';

var Config = require('../../../config');

class TableWorkList extends Component {

  constructor(props, context) {
    super(props, context);

    this.setValues    = this.setValues.bind(this);
    this.headChange   = this.headChange.bind(this);
    
    this.paginator = this.paginator.bind(this);
    this.onCheckAll = this.onCheckAll.bind(this);
    this.elementChange = this.elementChange.bind(this);
    this.removeFocus = this.removeFocus.bind(this);
    
    this.state = {
      lectinaValues:["1","2"],
      expanded: null,
      rh:[],
      group:[],
      columns:[],
      donations:[],
      lab_sections:[],
      lab_sections_id:"",

      pagination:[],
      patient:false,
    };
  }
 
  componentDidMount() {
    this.props.onRef(this);
    var patient = false;
    if(this.props.location.pathname === '/work_list/patient'){
      patient = true;
      this.setState({patient:patient});
    }

    fetch(Config.default.apiGateway.URL+'lookups?type=Rh&notrender=0',{ 
        method: 'get',
        headers: new Headers({
           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
           'Accept': 'application/json',
            'Content-Type': 'application/json',
        })
    })
    .then(response => response.json())
    .then(response => {
      this.setState({
          rh: response
        });
    })

    fetch(Config.default.apiGateway.URL+'lookups?type=BLOOD_GROUP&notrender=0',{ 
        method: 'get',
        headers: new Headers({
           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
           'Accept': 'application/json',
            'Content-Type': 'application/json',
        })
    })
    .then(response => response.json())
    .then(response => {
      this.setState({
          group: response
        });
    });

    var search = this.props.match.url.replace('/', '');

    if(patient){
      search = 'WORK_LIST_PATIENTS'
    }

    fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search='+search,{ 
      method: 'get',
      headers: new Headers({
         'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
         'Accept': 'application/json',
          'Content-Type': 'application/json',
      })
    })
    .then(response => response.json())
    .then(response => {
      if(response !== undefined){
        this.setState({ columns: response });
      }
    });    
  }

  componentWillUnmount() {
    this.props.onRef(null)
  }

  handleChangePanel = panel => (event, expanded) => {
      this.setState({
        expanded: expanded ? panel : false,
      });
  };

  getResults(){
    var res = [];

    this.state.donations.map((item) => {
      
      item.donations.map((don) => {
        var obj = {};

        if(this.state.patient){
          obj.samples_id = don.samples_id;
          obj.results = [];
        }else{
          obj.offers_id   = don.donation.offers_id;
          obj.offering_cell_id   = don.donation.offering_cell_id;
          obj.donation_id = don.donation.id;
          obj.donor_number = don.donation.donor_number;
          obj.sample_results = [];
        }
        
        
        
        don.analitical_test_array.map((test) => {
          var sample_results = {};
          if(test.analitical_test !== null){
            if(document.getElementById("analitical_test_"+test.analitical_test.id+don.donation.id) !== null){
              if(test.analitical_test !== null){
                if(typeof test.analitical_test.id === 'number'){
                  sample_results.analitical_test_id = test.analitical_test.id;
                  sample_results.value              = document.getElementById("analitical_test_"+test.analitical_test.id+don.donation.id).value;      
                }
              } 

              if(sample_results.value !== '' && sample_results.value !== undefined){
                if(!this.state.patient){
                  if(test.result !== null){
                    sample_results.id = test.result.id;
                  }
                  if(don.samples_id !== 0){
                    sample_results.samples_id = don.samples_id;
                    
                  }

                  obj.sample_results.push(sample_results);
                }else{
                  obj.results.push(sample_results);
                }
                
                
              }
            }
          }
            
        })
        if(!this.state.patient){
          if(obj.sample_results.length > 0){    
              if(don.samples_id !== 0){
                obj.id = don.samples_id;
              }
        
            res.push(obj);
          }
        }else{
          if(obj.results.length > 0){ 
            res.push(obj);
          }
        }
      })
    });

    return res;
  }

  elementChange(e){
      const selectedIndex = e.target.options.selectedIndex;
      var option_id = e.target.options[selectedIndex].getAttribute('data-key');

      this.validateAccept(e.target.id, option_id);
  }

  validateAccept(id, option){
    if(option !== null){
      this.state.donations.some((item)=>{
        item.donations.map((don)=>{
          don.analitical_test_array.map((test)=>{
            if(test.analitical_test !== null){
              if("analitical_test_"+test.analitical_test.id + don.donation.id === id){
              
                test.highlight.map((h)=>{
                  var index = test.results.findIndex(obj => 
                    h.settled_tex_id === obj.id && obj.id === option
                  );
                  if(index !== -1){
                    if(h.highlight){
                      document.getElementById(id).classList.add('error');
                      return false;
                    }else{
                      document.getElementById(id).classList.remove('error')
                    }
                  }
                })

                /*if(test.accepted_values !== null){
                  test.accepted_values.some((accept)=>{
                    if(test.analitical_test.is_antibody){
                      if(document.getElementById(id).value === 'POSITIVO'){
                        document.getElementById(id).classList.add('error');
                      }else{
                        document.getElementById(id).classList.remove('error');
                      }
                    }else{
                      if(accept.settled_text_at_id === parseInt(option,10)){
                        document.getElementById(id).classList.remove('error')
                        return accept.settled_text_at_id === parseInt(option,10);

                      }else{
                        if(document.getElementById(id).value !== ""){
                          document.getElementById(id).classList.add('error');
                        }
                        
                      } 
                    }
                    
                  })
                }*/

                


              
                  
              }
            }
          })
        })
      })
    }else{

      document.getElementById(id).classList.remove('error')
    }
   
  }

  changeValues(item, id){
    item.donations.map((don, i)=>{
      if(document.getElementById('row_'+item.work_list.code+don.donation.id) !== null){
        var row_donation = document.getElementById('row_'+item.work_list.code+don.donation.id).checked;

        don.analitical_test_array.map((obj_test)=>{
          if(obj_test.analitical_test){
            var check = document.getElementById('all_'+obj_test.analitical_test.code+item.work_list.id).checked;
            var validated = obj_test.result !== null ? obj_test.result.validated : false;
            
            if(id === 'header_'+obj_test.analitical_test.code+item.work_list.id){
              if(check && don.can_edit && !validated){
                if(id.indexOf(obj_test.analitical_test.code+item.work_list.id) !== -1){
                  if(row_donation){
                 
                    var val = document.getElementById('header_'+obj_test.analitical_test.code+item.work_list.id).value;
                    document.getElementById("analitical_test_"+obj_test.analitical_test.id + don.donation.id,10).value = val;
                    
                    const selectedIndex = document.getElementById('header_'+obj_test.analitical_test.code+item.work_list.id).options.selectedIndex;
                    var option = parseInt(document.getElementById('header_'+obj_test.analitical_test.code+item.work_list.id).options[selectedIndex].getAttribute('data-key')) || "";

                    this.validateAccept("analitical_test_"+obj_test.analitical_test.id + don.donation.id, option);
                  }
                }
              }

            }else if(id === 'all_'+obj_test.analitical_test.code+item.work_list.id){

              if(check && row_donation){
                document.getElementById('header_'+obj_test.analitical_test.code+item.work_list.id).value = "";           
              }
            
            }else if(id === 'row_'+item.work_list.code+don.donation.id){
               if(!row_donation){
                document.getElementById("analitical_test_"+obj_test.analitical_test.id + don.donation.id).classList.remove('error')
              }else{
                if(document.getElementById('header_'+obj_test.analitical_test.code+item.work_list.id) !== null){
                  var val = document.getElementById('header_'+obj_test.analitical_test.code+item.work_list.id).value;
                  var selectedIndex = "";
                  var option = 0;
                  if(check && don.can_edit && !validated){
                    document.getElementById("analitical_test_"+obj_test.analitical_test.id + don.donation.id).value = val; 
                    selectedIndex = document.getElementById('header_'+obj_test.analitical_test.code+item.work_list.id).options.selectedIndex;
                    option = parseInt(document.getElementById('header_'+obj_test.analitical_test.code+item.work_list.id).options[selectedIndex].getAttribute('data-key')) || "";
                  }else{
                    selectedIndex = document.getElementById("analitical_test_"+obj_test.analitical_test.id + don.donation.id).options.selectedIndex;
                    option = parseInt(document.getElementById("analitical_test_"+obj_test.analitical_test.id + don.donation.id).options[selectedIndex].getAttribute('data-key')) || "";
                  }
                  this.validateAccept("analitical_test_"+obj_test.analitical_test.id + don.donation.id, option);
                  
                }
              }
            }
          }
        })
      }
    })
  }

  headChange(e){
    var id = e.target.id;
    var value = e.target.value;

    this.state.donations.map((item)=>{
      return this.changeValues(item, id, value);
    })
  }

  setValues(item){
    item.donations.map((don, i)=>{

      item.headers_table.map((obj,index) =>{
        document.getElementById("all_"+obj.test_name+item.work_list.id).checked = false;
        document.getElementById("header_"+obj.test_name+item.work_list.id).value = "";
      });

      don.analitical_test_array.map((test)=>{
        if(test.analitical_test !== null){
          var id = "analitical_test_"+test.analitical_test.id+don.donation.id;

          if(document.getElementById(id) !== null){
            if(test.result !== null){
              if(test.result.value !== 'NO RESULT'){
                document.getElementById(id).value = test.result.value;
              }
              if(test.result.validated){
                document.getElementById(id).disabled = true;
                document.getElementById('mark_'+test.analitical_test.id+don.donation.id).style.display = "block";
              }

              var selectedIndex = document.getElementById(id).options.selectedIndex;
             
              if(selectedIndex !== -1){
                var option = parseInt(document.getElementById(id).options[selectedIndex].getAttribute('data-key')) || "";
                this.validateAccept(id, option);
              }                

            }else{
              document.getElementById(id).value = "";
            }
          }  
        }
      });
    });
  }

  editValues(){

    if(this.state.donations.length !== undefined){
      this.state.donations.map((item) => {
        this.setValues(item);
      });
    }else{
        this.setValues(this.state.donations);
    }
  }

  showColumn(column_name){
    var i =0;
    
    for(i =0; i < this.state.columns.length;i++){
      if(this.state.columns[i]=== column_name){
        return false;
      }
    }
    
    return true;
  }

  paginator(item, work_list, page, per_page){

    var page        = page || 1,
    per_page        = per_page || 20,
    offset          = (page - 1) * per_page,
    paginatedItems  = item.donations.slice(offset).slice(0, per_page),
    total_pages     = Math.ceil(item.donations.length / per_page);
    var pagination  = {
      page        : page,
      per_page    : per_page,
      pre_page    : page - 1 ? page - 1 : null,
      next_page   : (total_pages > page) ? page + 1 : null,
      total       : item.donations.length,
      total_pages : total_pages,
      work_list   : item.work_list.id,
      data        : paginatedItems
    }

    if(work_list === undefined){
      this.setState({
        pagination:[...this.state.pagination, pagination]
      })

    }else{
      var paginator = this.state.pagination;
      
      paginator.map(function(pag, i){
        if(pag.work_list === work_list){
          paginator[i] = pagination;
        }        
      })

      setTimeout(function(){
        this.setState({
          pagination: paginator
        })

        document.getElementById("check_all").checked = false;

        this.editValues();
      }.bind(this))
    }       
  }

  onCheckAll(e){
    this.state.donations.map((item, i)=>{
      return item.donations.map((don)=>{
        return document.getElementById('row_'+item.work_list.code+don.donation.id) !== null?
            e.target.checked ?
                document.getElementById('row_'+item.work_list.code+don.donation.id).checked = true
            : document.getElementById('row_'+item.work_list.code+don.donation.id).checked = false
        :null
      })
    });
  }

  validateInput(e) {
    const re = /^[-+]?$/;
    if (e.key === "Enter") {
        e.preventDefault(); // Prevent form submission if button present
        
        const form = e.target.form;
        const index = Array.prototype.indexOf.call(form, e.target);

        if(form.elements[index + 1] !== undefined){
          if(form.elements[index + 1].getAttribute("disabled") !== undefined){  
          if(form.elements[index + 1].getAttribute("disabled") === null){ 
            if(form.elements[index + 1].getAttribute("type") === 'checkbox'){
              form.elements[index + 1].focus();
              form.elements[index + 1].style.boxShadow = "0 0 5px 2px rgb(104, 173, 253)";
            
            }else{
              form.elements[index + 1].focus();
            }
            
          }else if(form.elements[index + 1].getAttribute("disabled") === ""){
            form.elements[index + 2].focus();
          }
            
          }
        }
    
      if (!re.test(e.key)) {
        e.preventDefault();
      }
    }
  }

  removeFocus(e){
    e.target.style.boxShadow = "0 0 5px 2px rgb(255, 255, 255)";
  }

  //Contenido de la tabla
  render () {
    const { t } = this.props;
    const { expanded } = this.state;

    return (
      <div className="col-xs-12 col-sm-12">
        <form noValidate>
          {/*LAB SECTIONS*/}
          {this.state.donations.length > 0 ?
            
            this.state.donations.map((don, i)=>{
              return <fieldset key={"fieldset_"+i}>
                          <legend style={{fontSize:"1.5em"}}>{don.work_list.name}</legend>

                          <div className="col-xs-12">
                            <Table responsive hover>
                              <thead>
                                <tr>
                                  <th>
                                    <input type="checkbox" id="check_all" onKeyPress={(e) => this.validateInput(e)} onBlur={this.removeFocus} onChange={this.onCheckAll} />
                                  </th>
                                  <th hidden={this.state.patient ? this.showColumn('SAMPLE_NUMBER') : this.showColumn('DONATION_NUMBER')} style={{width:"120px"}}>
                                    {this.state.patient ? 'No. Muestra' : t('content.work_list.donation_number')}
                                  </th>
                                  <th hidden={this.state.patient ? this.showColumn('SAMPLE_TIMESTAMP') : this.showColumn('EXTRACTION_DATE')}>
                                    {this.state.patient ? 'Fecha' : t('content.work_list.extraction_date')}
                                  </th>
                                  <th hidden={this.state.patient ? this.showColumn('PATIENT') : this.showColumn('DONOR_NAME')}>
                                    {this.state.patient ? 'Paciente' : t('content.work_list.donor_name')}
                                  </th>
                                  <th hidden={this.state.patient ? this.showColumn('PETITION_NUMBER') : this.showColumn('DONOR_ID')}>
                                    {this.state.patient ? 'No. Petición' : t('content.work_list.donor_number')}
                                  </th>
                                  {don.headers_table.map((obj,index) =>{
                                    return  <th key={obj.test_name}>
                                              <input type="checkbox" id={"all_"+obj.test_name+don.work_list.id} 
                                                onKeyPress={(e) => this.validateInput(e)} onBlur={this.removeFocus}
                                                onChange={this.headChange} style={{marginRight:"5px"}} />
                                              {obj.test_name}                                      
                                              {obj.test_type === "CUANTITATIVO"?
                                                <input type="number" step="0.001" className="form-control" onChange={ this.headChange }
                                                  onKeyPress={(e) => this.validateInput(e)} id={"header_"+obj.test_name+don.work_list.id} 
                                                  name={"header_"+obj.test_name+don.work_list.id}/>
                                                :
                                                <select className="form-control" id={"header_"+obj.test_name+don.work_list.id}
                                                    onChange={ this.headChange } onKeyPress={(e) => this.validateInput(e)}
                                                    name={"header_"+obj.test_name+don.work_list.id} >
                                                    <option value="">Seleccionar...</option>
                                                    {
                                                      obj.results.map(function(t) {
                                                        return <option key={t.id} data-key={t.id} value={t.value} >{t.value} </option>;
                                                      })
                                                    }
                                                </select>
                                              }
                                            </th>
                                  })
                                  }
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.pagination.map((pag, i)=>{
                                  return pag.data.length > 0 && pag.work_list === don.work_list.id ?
                                      pag.data.map((obj, j)=>{
                                        return <tr key={"donation_"+obj.donation.id}>
                                                <td><input type="checkbox" id={"row_"+don.work_list.code+obj.donation.id} 
                                                      onKeyPress={(e) => this.validateInput(e)} onBlur={this.removeFocus}
                                                      onChange={this.headChange} />
                                                </td>
                                                <td hidden={this.state.patient ? this.showColumn('SAMPLE_NUMBER') : this.showColumn('DONATION_NUMBER')}>{obj.donation.donation_number}</td>
                                                <td hidden={this.state.patient ? this.showColumn('SAMPLE_TIMESTAMP') : this.showColumn('EXTRACTION_DATE')}>{obj.extraction_date}</td>
                                                <td hidden={this.state.patient ? this.showColumn('PATIENT') : this.showColumn('DONOR_NAME')}>{obj.donor_name}</td>
                                                <td hidden={this.state.patient ? this.showColumn('PETITION_NUMBER') : this.showColumn('DONOR_ID')}>{obj.donor_number}</td>

                                                {this.state.patient &&
                                                  don.headers_table.map((head, index)=>{
                                                    var index_test = obj.analitical_test_array.findIndex(test => test.analitical_test.code === head.test_name);
                                                    return index_test !== -1 ?
                                                            <td key={"analitical_test_"+index}>
                                                              {obj.analitical_test_array[index_test].analitical_test !== null &&
                                                                  <div>
                                                                    {obj.analitical_test_array[index_test].type === "CUANTITATIVO"?
                                                                      <div className="col-xs-10" style={{padding:"0px"}}>
                                                                        <input type="number" step="0.001" className="form-control" onKeyPress={(e) => this.validateInput(e)}
                                                                          id={"analitical_test_"+obj.analitical_test_array[index_test].analitical_test.id + obj.donation.id} name={"analitical_test_"+obj.analitical_test_array[index_test].analitical_test.id}/>
                                                                      </div>
                                                                    :<div className="col-xs-10" style={{padding:"0px"}}>
                                                                      <select className="form-control" id={"analitical_test_"+obj.analitical_test_array[index_test].analitical_test.id + obj.donation.id}
                                                                            onChange={this.elementChange} onKeyPress={(e) => this.validateInput(e)}
                                                                            name={"analitical_test_"+obj.analitical_test_array[index_test].analitical_test.id} >
                                                                            <option value="">Seleccionar...</option>
                                                                            {
                                                                              obj.analitical_test_array[index_test].results.map(function(t) {
                                                                                return <option key={t.id} data-key={t.id} value={t.value} >{t.value} </option>;
                                                                              })
                                                                            }
                                                                        </select>
                                                                    </div>
                                                                    }
                                                                    <div id={"mark_"+obj.analitical_test_array[index_test].analitical_test.id + obj.donation.id} className="col-xs-1" style={{color:"green", display:"none"}}>
                                                                      <SvgIcon icon={checkmark} style={{paddingTop:"3px"}}/>
                                                                    </div>
                                                                  </div>
                                                              }
                                                            </td>
                                                          : <td key={index}></td>
                                                  })
                                                }
                                                {!this.state.patient &&
                                                  obj.analitical_test_array.map((obj_test, index) =>{
                                                    return <td key={"analitical_test_"+index}>
                                                            {obj_test.analitical_test !==null?
                                                              <div>
                                                                {obj_test.type === "CUANTITATIVO"?
                                                                  <div className="col-xs-10" style={{padding:"0px"}}>
                                                                    <input type="number" step="0.001" className="form-control" onKeyPress={(e) => this.validateInput(e)}
                                                                      id={"analitical_test_"+obj_test.analitical_test.id + obj.donation.id} name={"analitical_test_"+obj_test.analitical_test.id}/>
                                                                  </div>
                                                                :<div className="col-xs-10" style={{padding:"0px"}}>
                                                                  <select className="form-control" id={"analitical_test_"+obj_test.analitical_test.id + obj.donation.id}
                                                                        onChange={this.elementChange} onKeyPress={(e) => this.validateInput(e)}
                                                                        name={"analitical_test_"+obj_test.analitical_test.id} >
                                                                        <option value="">Seleccionar...</option>
                                                                        {
                                                                          obj_test.results.map(function(t) {
                                                                            return <option key={t.id} data-key={t.id} value={t.value} >{t.value} </option>;
                                                                          })
                                                                        }
                                                                    </select>
                                                                </div>
                                                                }
                                                                <div id={"mark_"+obj_test.analitical_test.id + obj.donation.id} className="col-xs-1" style={{color:"green", display:"none"}}>
                                                                  <SvgIcon icon={checkmark} style={{paddingTop:"3px"}}/>
                                                                </div>
                                                              </div>
                                                            :null}
                                                              
                                                          </td>

                                                    })
                                                }
                                              </tr>
                                      })
                                    :null
                                })}

                              </tbody>
                            </Table>
                            {this.state.pagination[i] !== undefined ?
                              <Pager>                          
                                <Pager.Item disabled={this.state.pagination[i].pre_page === null && this.state.pagination[i].work_list === don.work_list.id ? true : false}
                                  onClick={function(){this.paginator(don, don.work_list.id, this.state.pagination[i].pre_page)}.bind(this)} 
                                  href="#">Anterior</Pager.Item>
                                {' Página '+this.state.pagination[i].page+' de '+this.state.pagination[i].total_pages+' '}
                                <Pager.Item disabled={this.state.pagination[i].next_page === null && this.state.pagination[i].work_list === don.work_list.id ? true : false} 
                                  onClick={function(){this.paginator(don, don.work_list.id, this.state.pagination[i].next_page)}.bind(this)} 
                                  href="#">Siguiente</Pager.Item>                            
                              </Pager>
                            :null}

                          </div>
                    </fieldset>
            })
          : null
          }
        </form>
        
        <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)} />
      </div>
    );
  }
}

export default translate('translations')(TableWorkList)